import { useEffect, useState } from 'react';
import { isMobileClient } from '@ui/utils/isMobileClient';
import { useLocation } from 'react-router';

// TODO: extracto a client-specific constant
const stickyHeaderHeight = 140;

export type SidebarAdsProps = {
  ads: React.ReactNode[];
};

export function SidebarAds({ ads }: SidebarAdsProps) {
  const isMobile = isMobileClient();
  const [numberOfAds, setNumberOfAds] = useState<number | null>(1);
  const location = useLocation();
  const [url, setUrl] = useState(`${location.pathname}${location.search}`);

  useEffect(() => {
    const newUrl = `${location.pathname}${location.search}`;

    if (newUrl !== url) {
      setNumberOfAds(1);
      setUrl(newUrl);

      // @ts-expect-error FWP function
      if (typeof initEmbeds === 'function') {
        // @ts-expect-error FWP function
        initEmbeds();
      }
    }
  }, [location, url]);

  useEffect(() => {
    /**
     * timeout is needed as we want to do the calculations only when all the component requests
     * have finished loading the data
     */
    setTimeout(() => {
      // Calculate how many pairs of divs we need based on the initial viewport height
      const height = document.documentElement.scrollHeight - stickyHeaderHeight;
      const calculatedNumberOfAds = Math.floor(height / 1000);

      setNumberOfAds(Math.min(calculatedNumberOfAds, ads.length));
    }, 1000);
  }, [location.pathname]);

  return (
    <aside className="sidebar-ads-container">
      <div className="matches-list__video-ad" id="snack-vod" />
      {numberOfAds &&
        !isMobile &&
        Array.from({ length: numberOfAds }).map((_, index) => (
          <div className={'sidebar-ad'} key={`sidebar-ads-${index}`}>
            {ads[index]}
          </div>
        ))}
    </aside>
  );
}
